import { createErrorMessageTypeGuard } from './createErrorMessageTypeGuard';
import { makeRequest, CommonRequestOptions } from './makeRequest';

export type CompletionIndex = Record<number, number>;

export type CourseCompletion = {
   totalStagesAssigned: number;
   totalStagesCompleted: number;
   totalCompletion: number;
};

export async function getCourseCompletions(
   wikiids: number[],
   common: CommonRequestOptions = {}
): Promise<CompletionIndex> {
   const { completionPercents } = await makeRequest(
      'post',
      'course_assignments/completion/courses',
      {
         ...common,
         body: { wikiids },
      }
   );
   return completionPercents;
}

export async function getCourseCompletion(
   wikiid: number,
   common: CommonRequestOptions = {}
): Promise<CourseCompletion> {
   return await makeRequest('get', `course_assignments/completion/course/${wikiid}`, {
      ...common,
   });
}

export async function getTeamCourseCompletions(
   teamids: number[],
   common: CommonRequestOptions = {}
): Promise<CompletionIndex> {
   const { completionPercents } = await makeRequest('post', 'course_assignments/completion/teams', {
      ...common,
      body: { teamids },
   });
   return completionPercents;
}

type GetTeamCourseCompletionErrorCode = 'course_assignments.get_team_completions.team_not_found';

export async function getTeamCourseCompletion(
   teamid: number,
   common: CommonRequestOptions = {}
): Promise<number> {
   const { totalCompletion } = await makeRequest(
      'get',
      `course_assignments/completion/team/${teamid}`,
      {
         ...common,
      }
   );
   return totalCompletion;
}

getTeamCourseCompletion.errorMessages =
   createErrorMessageTypeGuard<GetTeamCourseCompletionErrorCode>();

export async function getUserCourseCompletion(
   userid: number,
   common: CommonRequestOptions = {}
): Promise<number> {
   const { totalCompletion } = await makeRequest(
      'get',
      `course_assignments/completion/user/${userid}`,
      {
         ...common,
      }
   );
   return totalCompletion;
}

export async function getUserCourseCompletions(
   userids: number[],
   common: CommonRequestOptions = {}
): Promise<CompletionIndex> {
   const { completionPercents } = await makeRequest('post', 'course_assignments/completion/users', {
      ...common,
      body: { userids },
   });
   return completionPercents;
}
